// extracted by mini-css-extract-plugin
export default {"header":"Header_header__-rIO1","logo":"Header_logo__u3lTp"};